import React, { useState, useEffect } from "react";
import { Button, Typography, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { doc, deleteDoc } from "@firebase/firestore";
import { ref, deleteObject } from "@firebase/storage";
import { firestore, storage } from "../../../../../firebase";
import { useAuth } from "../../../../../contexts/AuthContext";

import UploadProgress from "./UploadProgress";

const useStyles = makeStyles((theme) => ({
  cardDiv: {
    display: "flex",
    marginBottom: theme.spacing(2),
    alignItems: "center",
  },
  cardText: {
    flexGrow: 1,
  },
  check: {
    color: theme.palette.success.main,
    marginRight: theme.spacing(1),
  },
  uploadButton: {
    marginLeft: theme.spacing(1),
  },
  preview: {
    marginLeft: theme.spacing(1),
  },
  input: {
    display: "none",
  },
}));

export default function DocItem({ data, dbData }) {
  const classes = useStyles();
  const {currentUser} = useAuth();
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [check, setCheck] = useState(false);
  const [url, setUrl] = useState("");
  const [pathname, setPathname] = useState("");
  const [dbCheck, setDbCheck] = useState(false);
  const [dbUrl, setDbUrl] = useState("");
  const [dbPathname, setDbPathname] = useState("");

  useEffect(()=>{
    const match = dbData.filter((doc) => doc.id.toLowerCase() === data.name.toLowerCase());
    if (match.length === 1){
      setDbCheck(true);
      setDbUrl(match[0].url);
      setDbPathname(match[0].filePath);
      // console.log(match);
    }
  },[data,dbData])

  const handleUpload = (event) => {
    let selected = event.target.files[0];
    if (selected && selected.size < 5 * 10 ** 6) {
      setError("");
      setFile(selected);
    } else {
      setError("Exceeded 5MB");
      setFile(null);
    }
  };

  const handleDelete = async () => {
    try{
      setError("")
      setLoadingDelete(true);
      const docStorageRef = ref(storage, pathname ? pathname : dbPathname);
      const docFirestoreRef = doc(firestore, "User", currentUser.uid, "Documents", data.name);
      await deleteObject(docStorageRef);
      await deleteDoc(docFirestoreRef);
      setCheck(false);
      setDbCheck(false);
      setLoadingDelete(false);
    } catch (err){
      setError("Deleting Failed");
      setLoadingDelete(false);
    }
  }

  return (
      <div className={classes.cardDiv}>
        <Typography variant="body1" className={classes.cardText} gutterBottom>
          {data.name}
        </Typography>
        {error && <Typography variant="body1">{error}</Typography>}
        {file && (
          <UploadProgress
            file={file}
            setFile={setFile}
            uploadFor={data.name}
            setCheck={setCheck}
            setUrl={setUrl}
            setPathname={setPathname}
          />
        )}
        {loadingDelete && <CircularProgress style={{marginRight: 10}} />}
        {(check || dbCheck) && <CheckCircle className={classes.check} />}
        <div className={classes.uploadButton}>
          <input
            accept="application/pdf"
            className={classes.input}
            id={`${data.name}`}
            onChange={handleUpload}
            type="file"
          />
          <label htmlFor={`${data.name}`}>
            <Button variant="contained" color="primary" component="span">
              Upload
            </Button>
          </label>
        </div>
        {(check || dbCheck) && (
          <div>
            <Button
              variant="contained"
              color="secondary"
              className={classes.preview}
              onClick={handleDelete}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              color="primary"
              className={classes.preview}
              component={Link}
              target="_blank"
              to={{ pathname: url ? url : dbUrl }}
            >
              Preview
            </Button>
          </div>
        )}
      </div>
  );
}
